import React from 'react'
import { Link } from 'react-router-dom'

const KarteraLogo = ({ to = '/resumen', className = '', wordmarkClassName = '', onClick }) => (
    <Link
        to={to}
        onClick={onClick}
        aria-label="Kartera 365, ir al panel"
        className={`group flex shrink-0 items-center gap-1 ${className}`}
    >
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-k-line bg-k-bg transition-transform duration-[250ms] ease-out group-hover:rotate-[-2deg] group-hover:scale-[1.06]">
            <img src="/brand/favicon.svg" alt="" className="h-[1.7rem] w-[1.7rem]" />
        </span>
        <span className={`whitespace-nowrap text-[19px] font-extrabold tracking-[-0.02em] text-k-ink ${wordmarkClassName}`}>
            Kartera{' '}
            <span className="bg-gradient-to-r from-brand-cyan via-brand-purple to-brand-orange bg-clip-text text-transparent">365</span>
        </span>
    </Link>
)

export default KarteraLogo
